

export const base_url = ((process.env.NODE_ENV === 'production') ? "https://imagesizeconvertor.com"  : "http://localhost:5000")
